import React, { FC, useContext, useMemo } from 'react'
import { Grid } from '@mui/material'
import { WHITE } from '../../../theme'
import SvgSearch from '../../../icons/SvgSearch'
import Button from '../../../components/button/Button'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { Field, Form } from 'react-final-form'
import TextField from '../../../components/fields/TextField'
import { FILTRE_TEXTE } from '../utils/rechercheContactConstants'
import { FormulaireRechercheContact } from '../types/rechercheContactTypes'
import { buttonSize } from '../../../components/button/enums/buttonEnum'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router'
import links from '../../../enums/linksEnum'
import { RechercheContactContext } from './RechercheContactContext'

const HeaderRechercheContact: FC = () => {
	const { classes } = useStyles()
	const intl = useIntl()
	const navigate = useNavigate()
	const { setFiltreContact, rechercheLoading, filtreContact } = useContext(RechercheContactContext)

	const INITIAL_RECHERCHE_CONTACT: FormulaireRechercheContact = useMemo(() => ({
		[FILTRE_TEXTE]: filtreContact
	}), [filtreContact])

	const onSubmit = (values: FormulaireRechercheContact) => {
		setFiltreContact(values[FILTRE_TEXTE])
	}

	const validate = (values: FormulaireRechercheContact) => {
		const errors: any = {}
		if (!values[FILTRE_TEXTE] || values[FILTRE_TEXTE].length === 0) {
			errors[FILTRE_TEXTE] = intl.formatMessage({
				id: 'errors.required',
				defaultMessage: 'Requis*',
				description: 'Required field'
			})
		}
		return errors
	}

	return (
		<Grid container item padding="16px" alignItems="center" justifyContent="space-between">
			<Form
				initialValues={INITIAL_RECHERCHE_CONTACT}
				onSubmit={onSubmit}
				validate={validate}
				render={({ handleSubmit }) => (
					<form onSubmit={handleSubmit}>
						<Grid container item alignItems="center">
							<Grid container item xs>
								<Field
									name={FILTRE_TEXTE}
									component={TextField}
									label="rechercheContact.recherche.label"
									placeholder="rechercheContact.recherche.placeholder"
								/>
							</Grid>
							<Button
								buttonStyle={classes.searchIcon}
								background='backgroundAccessibility'
								color={WHITE}
								textStyle='text4'
								disabled={rechercheLoading}
							>
								<SvgSearch color={WHITE} width={15} height={15} />
							</Button>
						</Grid>
					</form>
				)}
			/>
			<Button
				background="backgroundAccessibility"
				color="colorWhite"
				textStyle="text4"
				size={buttonSize.small}
				onClick={() => navigate(links.CREATION_CONTACT)}
				buttonStyle={classes.buttonStyle}
				fullWidth
			>
				<FormattedMessage
					id="rechercheContact.btnCreation"
					defaultMessage="Créer un contact"
					description="Bouton pour créer un contact"
				/>
			</Button>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	searchIcon: {
		marginLeft: 17,
		height: 'fit-content',
		textTransform: 'inherit',
		padding: 10,
		minWidth: 45,
		minHeight: 45,
		borderRadius: 32,
		width: 'fit-content',
		cursor: 'pointer'
	},
	buttonStyle: {
		borderRadius: 25,
		maxWidth: 221
	}
}))

export default HeaderRechercheContact